import { assoc, filterObject } from '@range.io/functional'
import CanvasSourceSelectors from './canvas-source-slice/canvas-source-selectors.js'

/*
 * Return mapPositions, first Canvas and first CanvasSource for the project
 * @sig initialDataForSelectedProject :: State -> { {Id: MapPosition}, Canvas, CanvasSource }
 *  MapPosition = { center: { lng: Number, lat: Number }, zoom: Number }
 */
const initialDataForSelectedProject = state => {
    // pull the center from either the first CanvasSource for the canvas, or (for a PDF) from the project's center
    const mapPositionForCanvasId = (acc, canvasId) => {
        const canvas = state.canvases[canvasId]
        const canvasSource = CanvasSourceSelectors.canvasSourcesForCanvas(state, canvas)[0]
        const center = canvasSource.center ?? project.center // [lng, lat]

        const mapPosition = { center: { lng: center[0], lat: center[1] }, zoom: canvasSource.zoom ?? 19.8 }
        return assoc(canvasId, mapPosition, acc)
    }

    const project = state.projects[state.selectedProjectId]
    const mapPositions = project.canvasOrder.reduce(mapPositionForCanvasId, {})
    const firstCanvasId = project.canvasOrder[0]
    const firstCanvas = state.canvases[firstCanvasId]
    const firstCanvasSource = Object.values(filterObject(cs => cs.canvasId === firstCanvasId, state.canvasSources))[0]
    return { mapPositions, firstCanvas, firstCanvasSource }
}

export default initialDataForSelectedProject
